import { normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, renderSlot as _renderSlot, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, renderList as _renderList, createSlots as _createSlots, normalizeClass as _normalizeClass, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-24d2dede"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
    key: 0,
    class: "multiselect__single"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_ButtonElement = _resolveComponent("ButtonElement");
    const _component_Selection = _resolveComponent("Selection");
    const _component_ExternalFilterResetWrapper = _resolveComponent("ExternalFilterResetWrapper");
    return (_openBlock(), _createBlock(_component_ExternalFilterResetWrapper, {
        active: _ctx.isActive,
        size: _ctx.size,
        class: _normalizeClass(`table-filter filter-${_ctx.size === '' ? 'medium' : _ctx.size}`),
        onResetFilter: _ctx.onResetFilter
    }, {
        default: _withCtx(() => [
            _createVNode(_component_Selection, {
                ref: "filterSelection",
                modelValue: _ctx.notAppliedSelection,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((_ctx.notAppliedSelection) = $event)),
                "allow-empty": true,
                "close-on-select": false,
                disabled: false,
                options: _ctx.options,
                placeholder: _ctx.statusText,
                loading: _ctx.isLoading,
                "preserve-search": true,
                searchable: true,
                "show-checkboxes": _ctx.checkboxes,
                multiple: _ctx.multiple,
                "max-height": 250,
                "group-values": "groupOptions",
                "group-label": "groupName",
                label: "label",
                "track-by": "value",
                onClose: _ctx.setNotAppliedSelectionToActualSelection
            }, _createSlots({
                selection: _withCtx((props) => [
                    (props.selection.values.length > 0 && !props.selection.isOpen)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_1, _toDisplayString(_ctx.dropDownText), 1))
                        : _createCommentVNode("", true)
                ]),
                afterList: _withCtx(() => [
                    _createVNode(_component_ButtonElement, {
                        class: "px-0",
                        block: true,
                        text: _ctx.tr('common.APPLY'),
                        title: _ctx.tr('common.APPLY'),
                        variant: _ctx.BootstrapVariant.SECONDARY,
                        "icon-name": "checkmark",
                        onClick: _ctx.onApplyFiltersClicked
                    }, null, 8, ["text", "title", "variant", "onClick"])
                ]),
                _: 2
            }, [
                _renderList(_ctx.$slots, (_, slot) => {
                    return {
                        name: slot,
                        fn: _withCtx((scope) => [
                            _renderSlot(_ctx.$slots, slot, _normalizeProps(_guardReactiveProps(scope)), undefined, true)
                        ])
                    };
                })
            ]), 1032, ["modelValue", "options", "placeholder", "loading", "show-checkboxes", "multiple", "onClose"])
        ], undefined, true),
        _: 3
    }, 8, ["active", "size", "class", "onResetFilter"]));
}
